import { CallApi, handleJSONResponse } from "./common";
import { AnalyticsResults } from "../../../../services/analytics/types/analytics-results";

const callAPI = CallApi("analytics");

export const getAnalytics = async (
  artistId: string
): Promise<AnalyticsResults> => {
  const end = Number(new Date()) / 1000;
  const start = end - 30 * 24 * 60 * 60;

  const response = await callAPI(
    `/${artistId}?start=${start}&end=${end}`,
    "GET"
  );

  return await handleJSONResponse(response);
};
